import Vue from "vue";
import VueRouter from "vue-router";

import bzsdwPage from "@/pages/bzsdwPage";
import province from "@/pages/provincePage";
import loginPage from "@/pages/loginPage";
import city from "@/pages/cityPage";
import county from "@/pages/countyPage";
import company from "@/pages/companyPage";
import nation from "@/pages/nationPage";
import pointpro from "@/pages/pointproPage";
import pointlogPage from "@/pages/pointlogPage";
import notice from "@/pages/noticePage";
import vip from "@/pages/vipPage";

Vue.use(VueRouter);

const routes = [
  { path: "/", component: loginPage },
  { path: "/bzsdw", component: bzsdwPage },
  { path: "/province", component: province },
  { path: "/city", component: city },
  { path: "/county", component: county },
  { path: "/company", component: company },
  { path: "/nation", component: nation },
  { path: "/pointpro", component: pointpro },
  { path: "/pointlog", component: pointlogPage },
  { path: "/notice", component: notice },
  { path: "/vip", component: vip },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 获取缓存中的登录信息
  const dwform = JSON.parse(localStorage.getItem("dwform"));
  switch (to.path) {
    case "/":
      localStorage.clear("dwform");
      next();
      break;
    case "/bzsdw":
      if (dwform.type == 1) {
        next();
      } else {
        next(false);
      }
      break;
    case "/province":
      if (dwform.type == 2) {
        next();
      } else {
        next(false);
      }
      break;
    case "/city":
      if (dwform.type == 3) {
        next();
      } else {
        next(false);
      }
      break;
    case "/county":
      if (dwform.type == 4) {
        next();
      } else {
        next(false);
      }
      break;
    case "/company":
      if (dwform.type == 5) {
        next();
      } else {
        next(false);
      }
      break;
    case "/nation":
      if (dwform.type == 6) {
        next();
      } else {
        next(false);
      }
      break;
    case "/pointpro":
      next();
      break;
    case "/pointlog":
      next();
      break;
    case "/notice":
      next();
      break;
    case "/vip":
      next();
      break;
    default:
      next(false);
      break;
  }
  /*   if (to.path == "/") {
    next();
  }
  if (to.path == "/bzsdw") {
    if (dwform.type == 1) {
      next();
    } else {
      next(false);
    }
  }
  if (to.path == "/province") {
    if (dwform.type == 2) {
      next();
    } else {
      next(false);
    }
  }
  if (to.path == "/city") {
    if (dwform.type == 3) {
      next();
    } else {
      next(false);
    }
  }
  if (to.path == "/county") {
    if (dwform.type == 4) {
      next();
    } else {
      next(false);
    }
  }
  if (to.path == "/company") {
    if (dwform.type == 5) {
      next();
    } else {
      next(false);
    }
  } */
  /* next(false); */
});
export default router;
